export const GET_TASKS_LISTING = "GET_TASKS_LISTING";
export const GET_TASKS_DETAIL = "GET_TASKS_DETAIL";
export const TASK_FORM_DATA = "TASK_FORM_DATA";
export const GET_WORK_ORDERS_LISTING = "GET_WORK_ORDERS_LISTING";
export const GET_WORK_ORDERS_DETAIL = "GET_WORK_ORDERS_DETAIL";
